 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLABTNYUP_PRESS from '@/components/xhtml/abtnyup_press'
 import XHTMLCH001_HALFTITLE from '@/components/xhtml/ch001_halftitle'
 import XHTMLCH002_TITLE from '@/components/xhtml/ch002_title'
 import XHTMLCH003_COPYRIGHT from '@/components/xhtml/ch003_copyright'
 import XHTMLCH004_DEDIC from '@/components/xhtml/ch004_dedic'
 import XHTMLCH005_TOC from '@/components/xhtml/ch005_toc'
 import XHTMLCH006_ACK from '@/components/xhtml/ch006_ack'
 import XHTMLCH007_ABB from '@/components/xhtml/ch007_Abb'
 import XHTMLCH008_INTRO from '@/components/xhtml/ch008_intro'
 import XHTMLCH009_CH01 from '@/components/xhtml/ch009_ch01'
 import XHTMLCH010_CH02 from '@/components/xhtml/ch010_ch02'
 import XHTMLCH011_CH03 from '@/components/xhtml/ch011_ch03'
 import XHTMLCH012_CH04 from '@/components/xhtml/ch012_ch04'
 import XHTMLCH013_CH05 from '@/components/xhtml/ch013_ch05'
 import XHTMLCH014_CH06 from '@/components/xhtml/ch014_ch06'
 import XHTMLCH015_CONCLU from '@/components/xhtml/ch015_conclu'
 import XHTMLCH016_APP01 from '@/components/xhtml/ch016_app01'
 import XHTMLCH017_APP02 from '@/components/xhtml/ch017_app02'
 import XHTMLCH018_APP03 from '@/components/xhtml/ch018_app03'
 import XHTMLCH019_NOTES from '@/components/xhtml/ch019_notes'
 import XHTMLCH020_BIBLO from '@/components/xhtml/ch020_biblo'
 import XHTMLCH021_INDEX from '@/components/xhtml/ch021_index'
 import XHTMLCH022_ABOUT_THE_AUTHOR from '@/components/xhtml/ch022_about_the_author'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/cover",
 			"name" : "xhtml/cover",
 			"component" : XHTMLCOVER
 		},
 		{
 			"path" : "/xhtml/abtnyup_press",
 			"name" : "xhtml/abtnyup_press",
 			"component" : XHTMLABTNYUP_PRESS
 		},
 		{
 			"path" : "/xhtml/ch001_halftitle",
 			"name" : "xhtml/ch001_halftitle",
 			"component" : XHTMLCH001_HALFTITLE
 		},
 		{
 			"path" : "/xhtml/ch002_title",
 			"name" : "xhtml/ch002_title",
 			"component" : XHTMLCH002_TITLE
 		},
 		{
 			"path" : "/xhtml/ch003_copyright",
 			"name" : "xhtml/ch003_copyright",
 			"component" : XHTMLCH003_COPYRIGHT
 		},
 		{
 			"path" : "/xhtml/ch004_dedic",
 			"name" : "xhtml/ch004_dedic",
 			"component" : XHTMLCH004_DEDIC
 		},
 		{
 			"path" : "/xhtml/ch005_toc",
 			"name" : "xhtml/ch005_toc",
 			"component" : XHTMLCH005_TOC
 		},
 		{
 			"path" : "/xhtml/ch006_ack",
 			"name" : "xhtml/ch006_ack",
 			"component" : XHTMLCH006_ACK
 		},
 		{
 			"path" : "/xhtml/ch007_Abb",
 			"name" : "xhtml/ch007_Abb",
 			"component" : XHTMLCH007_ABB
 		},
 		{
 			"path" : "/xhtml/ch008_intro",
 			"name" : "xhtml/ch008_intro",
 			"component" : XHTMLCH008_INTRO
 		},
 		{
 			"path" : "/xhtml/ch009_ch01",
 			"name" : "xhtml/ch009_ch01",
 			"component" : XHTMLCH009_CH01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js